import React from 'react'
import { Row, Col, Card, theme } from 'antd'
import QuickActions from './QuickActions'
import Tasks from '../../../Dashboard/2025 New Dashboards/NewDoctorDashboard/components/Tasks'
import { NotificationsProvider } from '../../../Dashboard/2025 New Dashboards/NewDoctorDashboard/context/NotificationsContext'
import { WebSocketProvider } from '../../../Dashboard/2025 New Dashboards/NewDoctorDashboard/context/WebSocketContext'
import { ContainerCard } from '../../../reusable-components/AgiliteCards'
import './AdminDashboard.css'

const AdminDashboard = () => {
  const { token } = theme.useToken()

  return (
    <div className='admin-dashboard'>
      <ContainerCard bodyStyle={{ padding: 0 }}>
        {/* Header */}
        <div
          style={{
            background: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            padding: '32px',
            borderRadius: '8px 8px 0 0'
          }}
        >
          <div style={{ textAlign: 'left' }}>
            <h1
              style={{
                color: '#1e293b',
                margin: 0,
                fontSize: '28px',
                fontWeight: '600',
                marginBottom: '8px'
              }}
            >
              Practice Management
            </h1>
            <p
              style={{
                color: '#64748b',
                margin: 0,
                fontSize: '15px',
                fontWeight: '400'
              }}
            >
              Monitor and manage all your facilities from one central location
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div style={{ padding: '24px' }}>
          <Row gutter={[24, 24]} style={{ minHeight: '70vh' }}>
            {/* Quick Actions - Left Side */}
            <Col xs={24} lg={14} xl={16}>
              <QuickActions />
            </Col>

            {/* Task Board - Right Side */}
            <Col xs={24} lg={10} xl={8}>
              <div className='tasks-container' style={{ height: '100%' }}>
                <NotificationsProvider>
                  <WebSocketProvider>
                    <Tasks />
                  </WebSocketProvider>
                </NotificationsProvider>
              </div>
            </Col>
          </Row>
        </div>
      </ContainerCard>
    </div>
  )
}

export default AdminDashboard
